import React, {useEffect, useState} from 'react';
import Upload from './Upload';
import Edit from './Edit';
import Delete from './Delete';
import Moderation from './Moderation';
import './AdminPanel.css';
import GetAccessToken from "./Tokens";
import {useConfig} from "./ConfigContext";

const AdminPanel = () => {
    const [activeTab, setActiveTab] = useState('upload');
    const [hasModerationAccess, setHasModerationAccess] = useState(false);
    const config = useConfig();
    const moderationServiceUrl = config?.moderation_url;

    useEffect(() => {
        if (!config) return;
        const checkAccess = async () => {
            try {
                let access_token = await GetAccessToken(config["user_service_url"]);
                const response = await fetch(moderationServiceUrl + '/access_check', {
                    method: 'GET',
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${access_token}`
                    },
                });

                if (response.ok) {
                    setHasModerationAccess(true);
                } else {
                    setHasModerationAccess(false);
                }
            } catch (error) {
                console.error('Error checking moderation access:', error);
                setHasModerationAccess(false);
            }
        };

        checkAccess();
    }, [config]);

    return (
        <div className="admin-panel">
            <h1>Admin Panel</h1>
            <div className="tabs">
                <button
                    className={activeTab === 'upload' ? 'active' : ''}
                    onClick={() => setActiveTab('upload')}
                >
                    Upload
                </button>
                <button
                    className={activeTab === 'edit' ? 'active' : ''}
                    onClick={() => setActiveTab('edit')}
                >
                    Edit
                </button>
                <button
                    className={activeTab === 'delete' ? 'active' : ''}
                    onClick={() => setActiveTab('delete')}
                >
                    Delete
                </button>
                <button
                    className={`${activeTab === 'moderation' ? 'active' : ''} ${!hasModerationAccess ? 'disabled-tab' : ''}`}
                    onClick={() => hasModerationAccess && setActiveTab('moderation')}
                    disabled={!hasModerationAccess}
                    title={!hasModerationAccess ? 'Moderator access required' : ''}
                >
                    Moderation
                </button>
            </div>
            <div className="tab-content">
                <div style={{ display: activeTab === 'upload' ? 'block' : 'none' }}>
                    <Upload />
                </div>
                <div style={{ display: activeTab === 'edit' ? 'block' : 'none' }}>
                    <Edit />
                </div>
                <div style={{ display: activeTab === 'delete' ? 'block' : 'none' }}>
                    <Delete />
                </div>
                <div style={{ display: activeTab === 'moderation' ? 'block' : 'none' }}>
                    <Moderation />
                </div>
            </div>
        </div>
    );
};

export default AdminPanel;
